import '../navbars/nav-items/NavItems.scss';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown, Image, OverlayTrigger, Tooltip } from 'react-bootstrap';

import { useAppSelector, useAppDispatch } from 'redux/store';

import { updateUser } from '../../redux/slices/auth';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const dispatch = useAppDispatch();

  // Fetch language from Redux state
  const userData = useAppSelector((state) => state.auth.userData);
  const { language, user_settings } = userData || {};
  const { appLanguage } = user_settings || {};

  useEffect(() => {
    setTimeout(() => {
      const defaultLanguage = appLanguage || language || 'en'; // Default to 'en' if no language is set
      i18n.changeLanguage(defaultLanguage); // Set the language from Redux state on mount
    }, 0);
  }, []);

  const updateLanguage = async (lng) => {
    const payload = {
      user_settings: {
        ...user_settings,
        appLanguage: lng,
      },
    };

    try {
      const response: any = await dispatch(updateUser(payload));
    } catch (error) {
      console.error('Failed to update language', error);
    }
  };

  const languages = [
    { code: 'en', name: 'English', flag: 'https://flagcdn.com/w20/gb.png' }, // UK Flag
    { code: 'nl', name: 'Nederlands', flag: 'https://flagcdn.com/w20/nl.png' }, // Netherlands Flag
  ];

  // Change language manually through dropdown
  const changeLanguage = async (lng: string) => {
    await updateLanguage(lng);
    i18n.changeLanguage(lng);
  };

  // Get the current language from i18n
  const currentLanguage = languages.find((lng) => lng.code === i18n.language) || languages[0];

  return (
    <Dropdown>
      <OverlayTrigger
        placement="bottom"
        overlay={
          <Tooltip id="lang-tooltip" style={{ position: 'fixed' }}>
            Language
          </Tooltip>
        }
      >
        <Dropdown.Toggle as="div" id="dropdown-basic" className="dropdown-caret-none" style={{ cursor: 'pointer' }}>
          <div className="nav-icon-circle nav-icon-circle--blue">
            <Image src={currentLanguage.flag} alt={currentLanguage.name} style={{ width: '18px' }} />
          </div>
        </Dropdown.Toggle>
      </OverlayTrigger>

      <Dropdown.Menu>
        {languages.map((language) => (
          <Dropdown.Item key={language.code} onClick={() => changeLanguage(language.code)}>
            <Image src={language.flag} alt={language.name} style={{ width: '20px', marginRight: '5px' }} />
            {language.name}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default LanguageSwitcher;
